import { default as React, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import UploadConfigFormFields from './UploadConfigFormFields.tsx';
import SaveStatus from '../../core/components/SaveStatus.tsx';
import SettingsFormCard from '../../core/components/SettingsFormCard.tsx';
import { useToaster } from '../../core/components/Toast.tsx';
import countFieldErrors from '../../core/utils/countFieldErrors.ts';
import { clearInapplicableUploadFields } from '../uploadConfigFields.ts';

const FORM_DEFAULT_VALUES = {
    enabled: true,
    targetPathFileExport: '',
    targetPathOriginalDocument: '',
    sendOriginalDocument: true,
    sendOriginalEmail: false,
    deliveryMethod: 'SFTP',
};

const UploadConfig = ({ config, onActivate, onSubmit }) => {
    const { t } = useTranslation('config');
    const { publishToast } = useToaster();

    const form = useForm({ defaultValues: FORM_DEFAULT_VALUES, mode: 'onTouched' });

    useEffect(() => {
        if (!config) return;

        form.reset({
            enabled: config?.enabled,
            targetPathFileExport: config?.targetPathFileExport || '',
            targetPathOriginalDocument: config?.targetPathOriginalDocument || '',
            sendOriginalDocument: config?.sendOriginalDocument,
            sendOriginalEmail: config?.sendOriginalEmail,
            deliveryMethod: config?.deliveryMethod || '',
        });
    }, [config]);

    const handleSubmit = async (formData) => {
        try {
            if (!config) await onActivate();
            await onSubmit(clearInapplicableUploadFields(formData));
            publishToast({ description: t('configPage.upload.updateSuccess'), status: 'success' });
        } catch (e) {
            console.error(e);
            publishToast({ description: t('configPage.upload.updateError'), status: 'error' });
        }
    };

    return (
        <SettingsFormCard onSubmit={form.handleSubmit(handleSubmit)} title={t('configPage.upload.title')}>
            <UploadConfigFormFields form={form} />

            <SaveStatus
                isDirty={form.formState.isDirty}
                isSubmitting={form.formState.isSubmitting}
                errorCount={countFieldErrors(form.formState.errors)}
            />
        </SettingsFormCard>
    );
};

export default UploadConfig;
